import { DropdownMenu, GhostIconButton, MenuItem } from "@certn/cascadia-react";
import { t } from "i18next";
import React from "react";

interface Props {
  favouritesOrderingParam: string;
  setFavouritesOrderingParam: (param: string) => void;
}

export function FavouriteGroupsDropdownMenu(props: Props) {
  const { favouritesOrderingParam, setFavouritesOrderingParam } = props;

  return (
    <>
      <DropdownMenu
        testID="favourite-groups-sorting-dropdown-menu"
        triggerButton={
          <GhostIconButton
            size="small"
            icon="more_horiz"
            testID="open-sort-favourites-drop-down"
          />
        }
        placement="bottom right"
        headerTitle="Sort"
        hideSeparator
        onItemAction={(key) => {
          switch (key) {
            case "sort_by_recent_button":
              setFavouritesOrderingParam("created");
              break;
            case "sort_by_oldest_button":
              setFavouritesOrderingParam("-created");
              break;
            case "sort_by_a_z_button":
              setFavouritesOrderingParam("customer_group__name");
              break;
            case "sort_by_z_a_button":
              setFavouritesOrderingParam("-customer_group__name");
              break;
            default:
              break;
          }
        }}
      >
        <MenuItem
          id="sort_by_recent_button"
          testID="sort_by_recent_button"
          minWidth="196px"
          textColor="text-base"
          textStyle="input/text-field"
          iconPosition="right"
          iconTestID="sort_by_recent_button_icon"
          icon={favouritesOrderingParam === "created" ? "check" : undefined}
        >
          {t("Recent")}
        </MenuItem>
        <MenuItem
          id="sort_by_oldest_button"
          testID="sort_by_oldest_button"
          minWidth="196px"
          textColor="text-base"
          textStyle="input/text-field"
          iconPosition="right"
          iconTestID="sort_by_oldest_button_icon"
          icon={favouritesOrderingParam === "-created" ? "check" : undefined}
        >
          {t("Oldest")}
        </MenuItem>
        <MenuItem
          id="sort_by_a_z_button"
          testID="sort_by_a_z_button"
          minWidth="196px"
          textColor="text-base"
          textStyle="input/text-field"
          iconPosition="right"
          iconTestID="sort_by_a_z_button_icon"
          icon={
            favouritesOrderingParam === "customer_group__name"
              ? "check"
              : undefined
          }
        >
          {t("A-Z")}
        </MenuItem>
        <MenuItem
          id="sort_by_z_a_button"
          testID="sort_by_z_a_button"
          minWidth="196px"
          textColor="text-base"
          textStyle="input/text-field"
          iconPosition="right"
          iconTestID="sort_by_z_a_button_icon"
          icon={
            favouritesOrderingParam === "-customer_group__name"
              ? "check"
              : undefined
          }
        >
          {t("Z-A")}
        </MenuItem>
      </DropdownMenu>
    </>
  );
}
